export let UpstreamModulePatchType = /*#__PURE__*/function (UpstreamModulePatchType) {
  UpstreamModulePatchType["Cl"] = "cl-patch";
  UpstreamModulePatchType["Programming"] = "programming-patch";
  return UpstreamModulePatchType;
}({});